<template>
	<main class="mypage subscription">
		<article class="history">
			<h2>{{ getTitle(tab) }}</h2>
			<ul class="history_board">
				<li
					v-for="(item, index) in benefitData?.post"
					:key="index"
					class=""
					@click="$router.push(`/subscriber-board-detail/${item.post_pk}`)"
				>
					<p>{{ item.post_title }}</p>
					<p>
						<span>{{ dayjs(item.post_enrollment_date).format('YYYY-MM-DD') }}</span>
					</p>
				</li>
				<Pagination
					v-if="benefitData?.post_cnt"
					:current-page="Number(route.query.page ?? 1)"
					:total-count="benefitData?.post_cnt ? Math.ceil(benefitData?.post_cnt / 10) : 0"
					@set-page="
						async (page) => {
							router.replace({ query: { ...route.query, page: page } });
						}
					"
				/>
			</ul>
		</article>
	</main>
</template>
<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
// lib
import dayjs from 'dayjs';

// api
import { useGetPostBenefitApi } from '@/api/benefit';
// component
import Pagination from '@/components/layout/common/Pagination.vue';

const route = useRoute();
const router = useRouter();

const tab = route.query.tab as 'NORMAL' | 'ONE' | 'PREMIUM';
// -----api-----
const { data: benefitData } = useGetPostBenefitApi(
	computed(() => {
		return { tab: tab, page: Number(route.query.page ?? 1), row: 10 };
	})
);
// -----function-----
const getTitle = (tab: string) => {
	switch (tab) {
		case 'ONE':
			return '구독 전용 게시판';
		case 'PREMIUM':
			return '구독 전용 게시판(차트영웅)';
		case 'VIDEO':
			return '차트영웅 Live 녹화방송';
	}
};
</script>
<style lang="scss" scoped>
.subscription {
	max-width: 68rem;
	@media screen and (max-width: 1280px) {
		padding: 4rem 0 0 0;
	}
	.history {
		display: flex;
		flex-direction: column;
		gap: var(--space-xxx-large);
		width: 100%;
		padding-bottom: 7.2rem;
		@media screen and (max-width: 1280px) {
			padding-bottom: var(--bottomMenu-height);
			margin-bottom: 7.2rem;
		}
		h2 {
			font-size: var(--font-s-xx-large);
			font-weight: var(--font-w-semi-bold);
			line-height: 3rem;
			@media screen and (max-width: 1280px) {
				padding: 0rem 2rem;
			}
		}
		.history_board {
			li {
				cursor: pointer;
			}
			.pagination {
				margin-top: 2.4rem;
			}
		}
	}
}
</style>
